const randomFilename = fileType => `${fileType}${new Date().getTime()}.png`;

export default randomFilename;
